import NavigationControls from "./NavigationControls";
import PropTypes from "prop-types";
import React from "react";

export default class ExperimentalKindQuestion extends React.PureComponent {

  static propTypes = {
    "answers": PropTypes.array.isRequired,
    "header": PropTypes.element.isRequired,
    "multiSelect": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "patchSurvey": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "skip": PropTypes.object,
    "surveyFields": PropTypes.object.isRequired
  };

  static defaultProps = {
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  static kinds = [
    "bracelets",
    "earrings",
    "necklaces",
    "rings"
  ];

  static getDerivedStateFromProps (props, state) {
    // Skip first mount
    if (state.initialRender) {
      return {"initialRender": false};
    }

    return ExperimentalKindQuestion.kinds.reduce(
      (acc, kindName) => {
        acc[kindName] = props.surveyFields[kindName];
        return acc;
      },
      {}
    );
  }

  constructor (props) {
    super(props);

    /*
     * NOTE: Here we initialize these all to false, when productizing, read
     * from this.props.surveyFields[kind]
     */

    this.state = ExperimentalKindQuestion.kinds.reduce((acc, kindName) => {
      acc[kindName] = false;
      return acc;
    }, {"initialRender": true});
  }

  handleClick = (clickedKind) => {
    const {patchSurvey} = this.props;
    const {state} = this;
    const apiRequest = ExperimentalKindQuestion.kinds.reduce(
      (acc, kindName) => {
        acc[kindName] = state[kindName];
        return acc;
      },
      {}
    );
    // Toggle the value that was just clicked
    apiRequest[clickedKind] = !state[clickedKind];

    /*
     * When productizing, we should use:
     * onAnswer({[kind]: wasSelected}, true)
     */
    patchSurvey(apiRequest);
  }

  renderButton = ({prompt, image}) => {
    /* eslint-disable sort-vars */
    const kind = prompt.toLowerCase();
    // NOTE: when productizing should be `wasSelected = surveyFields[kind],`
    const {state} = this;
    const wasSelected = {...state}[kind];
    const selectClass = wasSelected ? "selected" : "shadowed";
    /* eslint-enable sort-vars */
    return (
      <img
        className={`mb24 experiment-kind ${kind} ${selectClass}`}
        key={prompt}
        onClick={() => this.handleClick(kind)} // eslint-disable-line react/jsx-no-bind
        src={`https://karat-herokuapp-com.freetls.fastly.net/s3media/style_survey/${image}.jpg`}
      />
    );
  }

  render () {
    const {answers, nextRoute, onAnswer, prevRoute, skip} = this.props;

    return (
      <div className="StyleSurveyQuestion">
        <h4 className="sub-header">
          Which types of jewelry do
          <br />
          you want to try?
        </h4>
        <p className="mb16">
          Select all that apply.
        </p>
        <div className="StyleSurveyAnswers experiment-kinds mb16">
          {
            answers.map(answer => this.renderButton(answer))
          }
        </div>
        <NavigationControls
          nextRoute={nextRoute}
          onAnswer={onAnswer}
          prevRoute={prevRoute}
          skip={skip}
        />
      </div>
    );
  }
}
